import { PercentageUpDown } from '@labrav/react-components'

import { isUndefined } from 'lodash'
import { useStyles } from './TotalAndPercentage.styles'
import { numberFormat } from '@labrav/common'

export type TotalAndPercentageProps = {
  percentage?: number
  total: number | string
  type?: 'up' | 'down'
  totalPrefix?: string
  label?: string
  currency?: string
}

export const TotalAndPercentage = ({
  percentage,
  totalPrefix,
  total,
  type,
  label,
  currency = '',
}: TotalAndPercentageProps) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root} data-testid={'total-and-percentage'}>
      <div className={classes.currency}>{currency}</div>
      <div className={classes.total}>
        {totalPrefix && (
          <span data-testid={'total-prefix-value'}>
            {totalPrefix}
            {''}
          </span>
        )}
        <span data-testid={'total-value'}>{numberFormat(total)}</span>
      </div>
      {type && !isUndefined(percentage) && (
        <div className={classes.percentage}>
          <PercentageUpDown percentage={percentage} type={type} lable={label} />
        </div>
      )}
    </div>
  )
}
